import { render, staticRenderFns } from "./SubCatalogForm.vue?vue&type=template&id=29b83621&scoped=true"
import script from "./SubCatalogForm.vue?vue&type=script&lang=js"
export * from "./SubCatalogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b83621",
  null
  
)

export default component.exports